import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import { Input, Select, InputNumber, DatePicker, Space } from 'antd';
import FormItem from "components/fields/FormItem";
import TextAreaField from "components/fields/TextAreaField";
import SwitchField from "components/fields/SwitchField";
import { requiredField } from '../../../../utils/crudSagaHelper';
import { renderLabel, displayFullName, 
	displayFarmNameLocation, selectSearchFilter 
} from '../../../../utils/index';
import SelectSearchField from 'components/fields/SelectSearchField';
import { getUserFarmers, getUserFarms } from '../../../../redux/dynamiclist/dynamicListState';
import { DATE_FORMAT } from '../../../../variables/constants';
import AnimalTypeAndBreed from "components/fields/AnimalTypeAndBreed";

const RegisterAnimalFields = ({recordData, mode, form, isAdmin=false, 
	requestingFarmerList, farmerList, doGetUserFarmers, userFarmList, requestingUserFarmList, doGetUserFarms, typeId, ...props}) => {

	const [animalTypes, setAnimalTypes] = useState([]);
	const [disableHeadcount, setDisableHeadcount] = useState(false);
	
	const doFilterAnimalTypeOption = (category) =>{
		form.setFieldsValue({type_id: null});
		const filteredTypes = recordData?.animalTypeOptions?.filter((data) => data.category === category);
		setAnimalTypes(filteredTypes);		
	}

	useEffect(() => {
		if(recordData){
			setDisableHeadcount(recordData.id > 0);
			doFilterAnimalTypeOption(recordData.category_id);
			
			if(isAdmin){
				if(recordData.user_details_id){
					doGetUserFarmers({user_details_id:recordData.user_details_id, asOptions: 1, user_type: 3});
					doGetUserFarms({user_details_id:recordData.user_details_id, asOptions: 1});
				}
			}			
		}
	}, [recordData]);

  	return (
    	<>
			<FormItem name="id" hidden>
				<Input type="hidden"/>
			</FormItem>

			<div className="form-column-4">
				<FormItem 
					name="tag_id"
					label="Tag ID"
				>
					{renderLabel(recordData?.id > 0 ? recordData?.tag_id : 'Auto generate') }                
				</FormItem>
				<AnimalTypeAndBreed 
					recordData={recordData} 
					mode={mode} 
					form={form}
					rules={[requiredField()]}
					typeId={typeId}
				/>
				
				<FormItem 
					name="gender_id"
					label="Gender"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<Select id="gender_id"
						allowClear={true}
						options={recordData?.genderOptions}
					/>					
					: renderLabel(recordData?.gender?.name)
					}                
				</FormItem>

				<FormItem 
					name="date_of_birth"
					label="Date of Birth"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<DatePicker id="date_of_birth"
						format={DATE_FORMAT}
					/>					
					: renderLabel(recordData?.date_of_birth)
					}                
				</FormItem>

				<FormItem 
					name="sire_id"
					label="Sire ID"
				>
					{mode === 'edit' ?
					<Select id="sire_id"
						allowClear={true}
						showSearch
						options={recordData?.sireOptions}
					/>					
					: renderLabel(recordData?.sire?.tag_id)
					}                
				</FormItem>

				<FormItem 
					name="dam_id"
					label="Dam ID"
				>
					{mode === 'edit' ?
					<Select id="dam_id"
						allowClear={true}
						showSearch
						options={recordData?.damOptions}
					/>							
					: renderLabel(recordData?.dam?.tag_id)
					}                
				</FormItem>

				<FormItem 
					name="birth_type_id"
					label="Birth Type"
				>
					{mode === 'edit' ?
					<Select id="birth_type_id"
						allowClear={true}
						options={[]}
					/>					
					: renderLabel(recordData?.birth_type?.name)
					}                
				</FormItem>

				<FormItem 
					name="horn_status_id"
					label="Horn Status"
				>
					{mode === 'edit' ?
					<Select id="horn_status_id"
						allowClear={true}
						options={recordData?.hornStatusOptions}
					/>					
					: renderLabel(recordData?.horn_status?.name)
					}                
				</FormItem>

				<FormItem 
					name="color"
					label="Color"
				>
					{mode === 'edit' ?
					<Input id="color"
						maxLength={30}		            		
					/>					
					: renderLabel(recordData?.color)
					}                
				</FormItem>

				<FormItem extra="col-span-1 md:col-span-2"
					name="farm_id"
					label="Farm / Location"
				>
					{mode === 'edit' ?
					<Select id="farm_id"
						allowClear={true}
						showSearch
						options={recordData?.farmLocations}
						filterOption={(input, option) =>
						      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
							}
					/>	
					: renderLabel(displayFarmNameLocation(recordData?.farm))
					}					
				</FormItem>
				
				<FormItem extra="col-span-1 md:col-span-3 xl:col-span-4"
					name="remarks"
					label="Notes or Remarks"
				>
					{mode === 'edit' ?
					<TextAreaField id="remarks"
						maxLength={1000}
					/>	
					: renderLabel(recordData?.remarks)
					}					
				</FormItem>
			</div>
	 	</>
  	);
};

const mapStateToProps = (state) => ({
	farmerList: state.dynamicList.userFarmers?.items,
	requestingFarmerList: state.dynamicList.userFarmers?.requesting,
	userFarmList: state.dynamicList.userFarms?.items,
	requestingUserFarmList: state.dynamicList.userFarms?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	doGetUserFarmers: (filters) => dispatch(getUserFarmers(filters)),
	doGetUserFarms: (filters) => dispatch(getUserFarms(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterAnimalFields);
